import { BrandfolderHexColors } from '@brandfolder/react';
import Image from 'next/image';
import Link from 'next/link';
import { AnchorHTMLAttributes, FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { BrandguideContext } from '@context/brandguide';
import { WhitelabelContext } from '@context/whitelabel';

interface HeaderLogoProps extends AnchorHTMLAttributes<HTMLAnchorElement> {}

const UnstyledHeaderLogo: FunctionComponent<HeaderLogoProps> = (props) => {
  const { brandguide } = useContext(BrandguideContext);
  const { whitelabel } = useContext(WhitelabelContext);

  const href = `${whitelabel.BRANDGUIDE_URL}${
    brandguide?.cname && brandguide?.public === false ? '/sign-in' : ''
  }`;

  return (
    <Link {...props} href={href} shallow={false}>
      <Image alt={'Return to home'} height={40} src={whitelabel.iconCdnUrl} width={40} />
    </Link>
  );
};

const StyledHeaderLogo = styled(UnstyledHeaderLogo)`
  border-radius: 2px;
  display: block;
  height: 40px;
  opacity: 1;
  width: 40px;
  transition: opacity 0.2s ease;

  &:focus {
    outline: 0;
  }

  &:hover {
    opacity: 0.8;
  }

  &:focus-within {
    outline-color: ${BrandfolderHexColors.Text};
    outline-offset: 2px;
    outline-style: solid;
    outline-width: 2px;
  }
`;

export const HeaderLogo: FunctionComponent<HeaderLogoProps> = (props) => {
  return <StyledHeaderLogo {...props} />;
};
